export default __webpack_public_path__ + "static/media/pse.7afb91e3.png";